export default {
  BASE_API_URL: "https://test4.services-money91.com/file91/",
  FILE_UPLOAD_URL: "https://test4.services-money91.com/upload_file/",
  // BASE_API_URL_MALL: "https://groupbuybe.payboard.in/saleService"
};

export const getBase64Url = (file) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  var base64 = new Promise(function (resolve, reject) {
    reader.onload = (event) => {
      if (event.target)
        resolve(event.target.result);
      else
        reject(new Error('fail'))
    };
  });
  return base64;
}